import { lazy } from 'react';
import { watchRecommendationClicks } from 'components/Recommendation/Recommendation.saga';
import { watchOpportunitiesActionsHome } from 'features/Opportunities/Opportunities.saga';
import { handleUserInsightsRouteEnter, watchUserInsightsModule } from './modules/UserInsights/UserInsights.saga';
import { handleSpotsAndBookingsRouteEnter, watchSpotsAndBookingsModule } from './modules/Bookings/Bookings.saga';
import {
  handleExcessInventoryRouteEnter,
  watchExcessInventoryModule,
} from './modules/ExcessInventory/ExcessInventory.saga';
import { watchHome, handleHomeRouteEnter } from './Home.saga';

const HomeContainer = lazy(() => import(/* webpackChunkName: "home" */ './HomeContainer'));

export default {
  path: '/home/:venueId?',
  component: HomeContainer,
  pathSagas: [
    handleExcessInventoryRouteEnter,
    handleSpotsAndBookingsRouteEnter,
    handleUserInsightsRouteEnter,
    watchExcessInventoryModule,
    watchHome,
    watchSpotsAndBookingsModule,
    watchUserInsightsModule,
    watchOpportunitiesActionsHome,
    watchRecommendationClicks,
  ],
  locationSagas: [handleHomeRouteEnter],
};
